export function getAge(regDate: string): number {
  const registrationDate = new Date(regDate);
  const currentDate = new Date();

  return currentDate.getFullYear() - registrationDate.getFullYear();
}
